<template>
  <div class="freight-report">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="80px">
      <el-form-item label="经营组织" prop="org">
        <ajax-select
          v-model="form.org"
          type="org"
          valueField="obj"></ajax-select>
      </el-form-item>
      <el-form-item label="订单编号" prop="orderNum">
        <el-input v-model="form.orderNum" placeholder="请输入订单编号"></el-input>
      </el-form-item>
       <el-form-item label="协议单号" prop="agreementNum">
        <el-input v-model="form.agreementNum" placeholder="请输入协议单号"></el-input>
      </el-form-item>
       <el-form-item label="提货单号" prop="takeOrderNo">
        <el-input v-model="form.takeOrderNo" placeholder="请输入提货单号"></el-input>
      </el-form-item>
      <el-form-item label="车牌号" prop="plateNum">
        <el-input v-model="form.plateNum" placeholder="请输入车牌号"></el-input>
      </el-form-item>
      <el-form-item label="提货区域" prop="areaId">
        <ajax-select v-model="form.areaId" type="area"></ajax-select>
      </el-form-item>
      <!-- 销售订单地区筛选条件 -->
      <template v-if="activeTab === '0'">
        <el-form-item label="目的地" prop="citis">
          <multi-cascader
            v-model="form.citis"
            :data="citisOptions"
            clearable
            ref="citisSelector"></multi-cascader>
        </el-form-item>
      </template>
      <!-- 调拨订单地区筛选条件 -->
      <template v-if="activeTab === '1'">
        <el-form-item label="目的地" prop="destination">
          <ajax-select v-model="form.destination" type="area"></ajax-select>
        </el-form-item>
      </template>
      <el-form-item label="开单时间" prop="invoiceTime">
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="销售" name="0">
        <freight-table :list="list" :columns="columns" :multi-select="false" :freight-type="0">
        </freight-table>
      </el-tab-pane>
      <el-tab-pane label="调拨" name="1">
        <freight-table :list="list"  :columns="columns" :freight-type="1" :multi-select="false">
        </freight-table>
      </el-tab-pane>
    </el-tabs>
    <div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listState.total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
      <div class="output-box" v-permission="'0170101'">
        每页<el-select class="select-page" v-model="form.pageSize" placeholder="请选择条数">
          <el-option
            v-for="item in sizeArr"
            :key="item.value"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>条
        第<el-select class="select-page" v-model="form.pageNo" placeholder="请输入页码">
          <el-option
            v-for="item in sizeNumber"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>页
        <el-button class="select-page-btn" type="primary" @click="handleExport()">导出</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatTime } from '../../../common/utils'
import AjaxSelect from '../../../components/ajaxSelect/index'
import MultiCascader from '../../../components/multiCascader/multi-cascader-base-element/multiCascader'
import FreightTable from '../freightPayoffReport/table.vue'

export default {
  data () {
    return {
      form: {
        org: {},
        deptName: '', // 经营组织名称
        orderNum: '', // 订单编号
        agreementNum: '', // 协议编号
        agreementType: 0, // 协议类型 1调拨/0销售
        takeOrderNo: '', // 提货单号
        plateNum: '', // 车牌号
        areaId: '', // 提货区域id
        destination: '', // 目的地
        isFreightSettle: ' ', // 是否结算运费
        isTicketArrival: ' ', // 是否到票
        invoiceTime: '',
        invoiceTimeMin: '', // 开始时间
        invoiceTimeMax: '', // 结束时间
        citis: [], // 省市区
        pageSize: 2000,
        pageNo: 1
      },
      dateRange: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)],
      columns: [ {
        name: '经营组织',
        prop: 'deptName'
      }, {
        name: '订单编号',
        prop: 'orderNum'
      }, {
        name: '协议号',
        prop: 'code',
        width: '120'
      }, {
        name: '客户名称',
        prop: 'consumerName',
        hide: false
      }, {
        name: '产品名称',
        prop: 'itemName',
        hide: false
      }, {
        name: '提货区域',
        prop: 'areaName'
      }, {
        name: '目的地',
        prop: 'toAddress'
      }, {
        name: '承运商',
        prop: 'carrierName'
      }, {
        name: '提货单号',
        prop: 'takeOrderNo'
      }, {
        name: '车牌号',
        prop: 'plateNum'
      }, {
        name: '司机姓名',
        prop: 'driverName'
      }, {
        name: '预装量',
        prop: 'preTakeCount'
      }, {
        name: '实发量',
        prop: 'netSend'
      }, {
        name: '实收量',
        prop: 'netReceipts'
      }, {
        name: '运费单价',
        prop: 'freightPrice'
      }, {
        name: '总运费',
        prop: 'freightPayAmount'
      }],
      sizeArr: [
        { value: '', label: '1000' },
        { value: 1, label: '5000' },
        { value: 2, label: '10000' },
        { value: 3, label: '20000' }
      ],
      activeTab: '0',
      citisOptions: [],
      payMultiSelection: [], // 销售多选
      transferMultiSelection: [] // 调拨多选
    }
  },
  computed: {
    ...mapGetters({ list: 'getStatisticalReportFreightList', listState: 'getStatisticalReportFreightListState' }),
    sizeNumber () {
      if (this.listState.total) {
        const maxNo = Math.ceil(this.listState.total / this.form.pageSize) + 1
        const newArr = [...new Array(maxNo).keys()]
        newArr.shift()
        return newArr
      } else {
        return [1]
      }
    }
  },
  watch: {
    dateRange: {
      handler (val) {
        if (val.length) {
          this.form.invoiceTimeMin = val[0]
          this.form.invoiceTimeMax = val[1]
        }
      },
      deep: true,
      immediate: true
    },
    activeTab: {
      handler (val) {
        this.form.agreementType = parseInt(val)
        this.handleSearch()
      },
      immediate: true
    },
    'form.org': {
      handler (val) {
        if (val.name === '全部') {
          this.form.deptName = ''
        } else {
          this.form.deptName = val.name
        }
      },
      immediate: true
    }
  },
  components: {
    AjaxSelect,
    MultiCascader,
    FreightTable
  },
  mounted () {
    this.initCitis()
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getCityInfo', 'getStatisticalReportFreightList', 'exportFreightReport']),
    handleSearch () {
      this.getStatisticalReportFreightList({ ...this.form, pageNo: 1, pageSize: 10 })
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 20000
      this.transferMultiSelection = []
      this.payMultiSelection = []
      this.dateRange = this.createCurrentTime()
      this.form.invoiceTimeMin = this.dateRange[0]
      this.form.invoiceTimeMax = this.dateRange[1]
      this.$refs['form'].resetFields()
      // this.$refs['citisSelector'].reset()
      if (this.form.agreementType === 0) {
        if (this.$refs['citisSelector']) {
          this.$refs['citisSelector'].reset()
        }
      }
      this.form.deptName = ''
      this.handleSearch()
    },
    createCurrentTime () {
      const date = new Date()
      const firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1)
      return [formatTime(firstDay, true), formatTime(date, true)]
    },
    handleCurrentChange (val) {
      this.getStatisticalReportFreightList({ pageNo: val })
    },
    handleSizeChange (val) {
      this.getStatisticalReportFreightList({ pageSize: val, pageNo: 1 })
    },
    handleExport () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportFreightReport({ ...this.form }).then((res) => {
          if (res.type !== 'application/json') {
            var createDownloadFile = function downloadFile () {
              let blobObject = new Blob([res])
              let fileName = '承运商运费报表.xls'
              // 兼容 IE系列 浏览器
              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName)
              } else {
                let link = document.createElement('a')
                link.download = fileName
                link.style.display = 'none'
                link.target = '_Blank'
                link.href = window.URL.createObjectURL(blobObject)
                // console.log(link)
                document.body.appendChild(link)
                link.click()
                window.URL.revokeObjectURL(link.href)
              }
            }
            createDownloadFile()
            this.$message.success('导出成功')
            this.form.pageNo = 1
            this.form.pageSize = 20000
          } else {
            this.$message.error('操作过于频繁,请30S后再试!')
          }
        })
      })
        .catch(() => {
        })
    },
    initCitis () {
      this.getCityInfo().then(res => {
        this.citisOptions = res
        for (let i = 0; i < this.citisOptions.length; i++) {
          const item = this.citisOptions[i]
          item.value = item.id
          item.label = item.name
          if (item.children && Array.isArray(item.children)) {
            for (let j = 0; j < item.children.length; j++) {
              const city = item.children[j]
              city.value = city.id
              city.label = city.name
              if (city.children && Array.isArray(city.children)) {
                for (let k = 0; k < city.children.length; k++) {
                  const deep = city.children[k]
                  deep.value = deep.id
                  deep.label = deep.name
                }
              }
            }
          }
        }
      })
    },
    MultiSelect (e, type) {
      if (type === 0) {
        this.payMultiSelection = e
      } else if (type === 1) {
        this.transferMultiSelection = e
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.output-box{
  margin-top: 20px;
  text-align: right;
}
.select-page{
  width: 98px;
  margin: 0 15px;
}
.select-page-btn{
  width: 120px;
  margin: 0 15px;
}
.operate-dropdown {
  margin-left: 10px;
}
</style>
